import { User } from "@fairfleet/geotab";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import { useEffect } from "react";
import { PageLink } from "@/constants/groupConfig";
import { useLicenseCheck } from "@/hooks/pageLicenseCheck/useLicenseCheck";

interface Props {
  page: PageLink;
  me: User | null;
  setCurrentPage: (page: PageLink) => void;
  finishedLoading: () => void;
}

export default function PageGridItem({ page, setCurrentPage, me, finishedLoading }: Props) {
  const { licensedState, isDmGroupLoading } = useLicenseCheck(page.groupName, me);
  useEffect(() => {
    if (!isDmGroupLoading) {
      finishedLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDmGroupLoading]);

  if (licensedState !== 1) return <></>;

  return (
    <Grid item xs={12} sm={6} md={4} key={page.name}>
      <Card
        style={{ borderRadius: 12, textAlign: "center", padding: "16px", cursor: "pointer" }}
        sx={{
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            boxShadow: 6,
            transform: "scale(1.05)",
          },
        }}
        onClick={() => setCurrentPage(page)}
      >
        <Icon>{page.icon}</Icon>
        <CardContent>
          <Typography variant="h6">{page.name}</Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
